"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var graphql_tag_1 = require("graphql-tag");
var react_apollo_1 = require("react-apollo");
var I18n = require("i18n-js");
var tracker_1 = require("../tracker");
var react_tracking_1 = require("react-tracking");
var bind_1 = require("../bind");
var classNames = require("classnames");
var elog = require("../elog");
var lodash_1 = require("lodash");
var user_context_provider_1 = require("./user_context_provider");
var mparticle_tracker_1 = require("../elog/mparticle_tracker");
var nudge_manager_1 = require("../nudge_manager");
var COMPONENT_NAME = 'watch_badge';
exports.createWatch = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      mutation CreateMyWatches($input: Input_core_apimessages_WatchesCreateRequest) {\n        createWatch(input: $input) {\n          id\n          listing {\n            id\n            _id\n            watching\n          }\n        }\n      }\n    "], ["\n      mutation CreateMyWatches($input: Input_core_apimessages_WatchesCreateRequest) {\n        createWatch(input: $input) {\n          id\n          listing {\n            id\n            _id\n            watching\n          }\n        }\n      }\n    "]))), {
    name: 'createWatch',
    options: function (ownProps) { return ({
        variables: {
            input: {
                listingId: ownProps.listing.id,
                channel: ownProps.watchSource,
            },
        },
        optimisticResponse: {
            __typename: 'Mutation',
            createWatch: {
                __typename: 'core_apimessages_UpdateWatchResponse',
                id: -1,
                listing: {
                    id: ownProps.listing.id,
                    _id: ownProps.listing._id,
                    watching: true,
                    __typename: 'Listing',
                },
            },
        },
    }); },
});
exports.deleteWatch = react_apollo_1.graphql(graphql_tag_1.default(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      mutation DeleteMyWatches($input: Input_core_apimessages_WatchesDeleteRequest) {\n        deleteWatch(input: $input) {\n          id\n          listing {\n            _id\n            id\n            watching\n          }\n        }\n      }\n    "], ["\n      mutation DeleteMyWatches($input: Input_core_apimessages_WatchesDeleteRequest) {\n        deleteWatch(input: $input) {\n          id\n          listing {\n            _id\n            id\n            watching\n          }\n        }\n      }\n    "]))), {
    name: 'deleteWatch',
    options: function (ownProps) { return ({
        variables: {
            input: { listingId: ownProps.listing.id },
        },
        optimisticResponse: {
            deleteWatch: {
                __typename: 'core_apimessages_UpdateWatchResponse',
                id: -1,
                listing: {
                    id: ownProps.listing.id,
                    _id: ownProps.listing._id,
                    watching: false,
                    __typename: 'Listing',
                },
            },
        },
    }); },
});
var withTracking = react_tracking_1.default(function (props) {
    return {
        componentName: COMPONENT_NAME,
        type: tracker_1.LISTING_TYPE,
        entityId: props.listing.id,
        url: window.location.href,
    };
});
var WatchBadge = /** @class */ (function (_super) {
    tslib_1.__extends(WatchBadge, _super);
    function WatchBadge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WatchBadge.prototype.handleWatch = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var watching, action, productActionType, eventName, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        watching = this.props.listing.watching;
                        action = watching ? 'unwatch' : 'watch';
                        productActionType = watching ?
                            mparticle_tracker_1.ProductActionType.RemoveFromWishlist : mparticle_tracker_1.ProductActionType.AddToWishlist;
                        eventName = watching ?
                            mparticle_tracker_1.MParticleEventName.RemoveFromWishlist : mparticle_tracker_1.MParticleEventName.AddToWishlist;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        if (!this.props.listing.watching) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.props.deleteWatch()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.props.createWatch()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        this.trackClick(action, productActionType, eventName);
                        if (this.props.handleWatchCreated) {
                            this.props.handleWatchCreated();
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        e_1 = _a.sent();
                        this.props.onError(e_1);
                        elog.error(e_1.message, { action: action, componentName: COMPONENT_NAME, listingId: this.props.listing.id }, e_1);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    WatchBadge.prototype.trackClick = function (action, productActionType, eventName) {
        this.props.tracking.trackEvent({
            interactionType: tracker_1.CLICK,
            context: { action: action },
            mParticleInteraction: {
                productActionType: productActionType,
                eventName: eventName,
                listing: this.props.listing,
                position: this.props.position,
                componentName: this.props.parentComponentName,
            },
        });
    };
    WatchBadge.prototype.getTitle = function () {
        if (this.props.isMoveAction)
            return I18n.t('commons.watchBadge.move');
        if (this.props.listing.watching)
            return I18n.t('commons.watchBadge.unwatch');
        return I18n.t('commons.watchBadge.watch');
    };
    WatchBadge.prototype.userLoggedOut = function () {
        return !!lodash_1.get(this.props, 'user.loggedOut', true);
    };
    WatchBadge.prototype.handleClick = function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (this.userLoggedOut() && !!this.props.handleLoggedOutUser) {
            this.props.handleLoggedOutUser(evt);
            return;
        }
        this.handleWatch();
    };
    WatchBadge.prototype.renderWatchersCount = function () {
        var count = lodash_1.get(this.props.listing, 'counts.watchers', 0);
        if (!this.props.includeCount || count === 0) {
            return null;
        }
        return (React.createElement("span", { className: "watch-badge__count" }, I18n.t('commons.watchBadge.watchers', { count: count })));
    };
    WatchBadge.prototype.renderText = function () {
        if (!this.props.includeText && !this.props.isMoveAction)
            return null;
        return (React.createElement("span", { className: "watch-badge__text" },
            this.getTitle(),
            this.renderWatchersCount()));
    };
    WatchBadge.prototype.renderNudge = function () {
        if (!this.props.enableNudge)
            return null;
        var nudgeText = nudge_manager_1.getWatchNudgeText(this.props.user, this.props.listing);
        if (!nudgeText)
            return null;
        return (React.createElement("div", { className: "watch-badge__nudge" }, nudgeText));
    };
    WatchBadge.prototype.render = function () {
        if (this.userLoggedOut() && !this.props.handleLoggedOutUser) {
            return null;
        }
        var classes = classNames('watch-badge', { 'watch-badge--watching': this.props.listing.watching }, { 'watch-badge--with-text': this.props.includeText }, { 'watch-badge--move': this.props.isMoveAction }, { 'watch-badge--button': this.props.renderAsButton });
        return (React.createElement("div", { className: classes },
            React.createElement("button", { className: "watch-badge__button", onClick: this.handleClick, title: this.getTitle() },
                React.createElement("div", { className: "watch-badge__inner" },
                    React.createElement("span", { className: "watch-badge__icon" }),
                    this.renderText())),
            this.renderNudge()));
    };
    WatchBadge.defaultProps = {
        onError: function () { return null; },
    };
    tslib_1.__decorate([
        bind_1.default
    ], WatchBadge.prototype, "handleClick", null);
    return WatchBadge;
}(React.Component));
exports.WatchBadge = WatchBadge;
exports.default = react_apollo_1.compose(user_context_provider_1.withUserContext, exports.createWatch, exports.deleteWatch, withTracking)(WatchBadge);
var templateObject_1, templateObject_2;
//# sourceMappingURL=watch_badge.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/watch_badge.js
// module id = VmEg
// module chunks = 0 1 2 3 4 6 8 11 12 13 20